import GlobalPagesWrapper from "@components/layouts/globalPagesWrapper";
import PartnerWithUs from "@components/shared/partnerWithUs";
import { getPageProps } from "@services/initial-calls";
import { GetServerSideProps } from "next";

export default function Index() {
    return (
        <GlobalPagesWrapper>
            <style jsx global>{`
                body {
                    overflow-x: unset;
                }
            `}</style>
            <PartnerWithUs />
        </GlobalPagesWrapper>
    );
}

export const getServerSideProps: GetServerSideProps = async (context) => {
    return await getPageProps(context, "partner-with-us");
};
